import React from 'react'
import Banner from './Banner/Banner'
import CoinsTable from './CoinsTable'

const Homepage = () => {
  return (
    <>
    <Banner></Banner>
    <CoinsTable></CoinsTable>
    </>
  )
}

export default Homepage